import React, { useState, useEffect, useCallback } from "react";
// import "./Snackbar.css";

export type SnackbarType = "success" | "error" | "info" | "warning";

interface SnackbarProps {
  message: string;
  type: SnackbarType;
  show: boolean;
  onClose: () => void;
  duration?: number;
}

const Snackbar: React.FC<SnackbarProps> = ({
  message,
  type,
  show,
  onClose,
  duration = 3000,
}) => {
  
  const [isVisible, setIsVisible] = useState(false);

  const handleClose = useCallback(() => {
    setIsVisible(false);
    setTimeout(() => {
      onClose();
    }, 300);
  }, [onClose]);

  useEffect(() => {
    if (show) {
      setIsVisible(true);
      const timer = setTimeout(() => {
        handleClose();
      }, duration);
      return ;
    } else {
      setIsVisible(false);
    }
  }, [show, duration, handleClose]);

  if (!show && !isVisible) return null;

  return (
    <div className={`snackbar snackbar-${type} ${isVisible ? "show" : "hide"}`}>
      <span>{message}</span>
      <button onClick={handleClose} aria-label="Close snackbar">
        &times;
      </button>
    </div>
  );
};

export default Snackbar;
















